/**
 * Enable reCAPTCHA to use recaptcha.net domain
 * This utility automatically configures reCAPTCHA when imported
 */

/**
 * Configure reCAPTCHA to use recaptcha.net domain
 * @returns {boolean} - Returns true if configuration was successful, false otherwise
 */
const enableRecaptchaNet = () => {
  // Check if we're in a browser environment
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return false;
  }

  try {
    // Remove existing script if it exists
    const existingScript = document.getElementById('recaptcha-net-config');
    if (existingScript) {
      existingScript.remove();
    }

    // Create and inject the script to enable recaptcha.net
    const script = document.createElement('script');
    script.id = 'recaptcha-net-config';
    script.innerHTML = `
      window.recaptchaOptions = {
        useRecaptchaNet: true
      };
    `;

    // Insert the script as early as possible in the head
    document.head.insertBefore(script, document.head.firstChild);
    
    console.log('reCAPTCHA configured to use recaptcha.net domain');
    return true;
  } catch (error) {
    console.error('Failed to enable reCAPTCHA.net configuration:', error);
    return false;
  }
};

/**
 * Check if reCAPTCHA is configured to use recaptcha.net
 * @returns {boolean} - Returns true if configured for recaptcha.net
 */
export const isRecaptchaNetEnabled = () => {
  if (typeof window === 'undefined') return false;
  return window.recaptchaOptions?.useRecaptchaNet === true;
};

/**
 * Reset reCAPTCHA configuration
 */
export const resetRecaptchaConfig = () => {
  const existingScript = document.getElementById('recaptcha-net-config');
  if (existingScript) {
    existingScript.remove();
  }
  
  if (typeof window !== 'undefined' && window.recaptchaOptions) {
    delete window.recaptchaOptions.useRecaptchaNet;
  }
};

// Auto-enable recaptcha.net when this module is imported
if (typeof window !== 'undefined') {
  enableRecaptchaNet();
}

export default enableRecaptchaNet;
